import { useEffect, useRef, useState } from "react"
import { Toaster } from "react-hot-toast"
import { translations } from '../../configs/translations'
import { FreeroamService } from "../../services/FreeroamService"
import { useStore } from '../../store/store'
import { EventPreparation } from '../driftEvents/preparation/EventPreparation'
import { DriftHud } from "../hud/drift/DriftHud"
import { FreeroamControls } from "./controls/FreeroamControls"
import "./Freeroam.css"
import { FreeroamMenu } from './freeroamMenu/FreeroamMenu'
import { DriftIndicator } from './hud/driftIndicator/DriftIndicator'
import { FreeroamHud } from "./hud/FreeroamHud"
import { FreeroamInviteList, InviteData } from "./invites/FreeroamInviteList"

export interface FreeroamDataUpdate {
    type: 'MONEY' | 'EXPERIENCE'
    amount: number
    newTotal: number
}

export const Freeroam = () => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]

    const [hudState, setHudState] = useState(false)
    const [incomingInvite, setIncomingInvite] = useState<InviteData | null>(null)
    const [dataUpdate, setDataUpdate] = useState<FreeroamDataUpdate | null>(null)

    const eventSourceRef = useRef<EventSource | null>(null)

    useEffect(() => {
        const token = localStorage.getItem("accessToken") || ""
        const es = FreeroamService.getInviteSSE(token)

        eventSourceRef.current = es

        es?.addEventListener("INIT", (e: Event) => {
            const messageEvent = e as MessageEvent
            console.log("SSE connected:", messageEvent.data)
        })

        es?.addEventListener("MATCHMAKING_INVITE", (e: Event) => {
            const messageEvent = e as MessageEvent
            const inviteData = JSON.parse(messageEvent.data) as InviteData

            const menuSound = new Audio("./sounds/menu_sound_1.wav")
            menuSound.play()

            setIncomingInvite(inviteData)
        })

        es?.addEventListener("FREEROAM_DATA_UPDATE", (e: Event) => {
            const messageEvent = e as MessageEvent
            const data = JSON.parse(messageEvent.data) as FreeroamDataUpdate
            setDataUpdate(data)

            setTimeout(() => {
                setDataUpdate(null)
            }, 10000)
        })

        return () => {
            eventSourceRef.current?.close()
            eventSourceRef.current = null
        }
    }, [])

    return (
        <div tabIndex={0}>
            <FreeroamHud dataUpdate={dataUpdate} />

            <DriftIndicator status={hudState} />

            <div className='freeroam-menu-wrapper'>
                <FreeroamMenu />
            </div>

            <FreeroamControls
                onToggleHud={() => setHudState(prev => !prev)}
            />

            <FreeroamInviteList incomingInvite={incomingInvite} />

            {hudState && <DriftHud />}

            <EventPreparation eventSource={eventSourceRef.current} />

            <Toaster position="bottom-center" />
        </div>
    )
}